
export const calculateYield = (askingPrice: number, monthlyPayment: number, remainingTermMonths?: number, balloonPayment?: number): string => {
  if (!askingPrice || !monthlyPayment) {
    return '';
  }

  // If we don't have term and balloon info, fall back to simple calculation
  if (!remainingTermMonths) {
    const yieldValue = Math.round(((monthlyPayment * 12) / askingPrice) * 100 * 100) / 100;
    return `${yieldValue}%`;
  }

  // Use iterative method to find yield (same as Note Discount Calculator)
  let lowYield = 0.001; // 0.1%
  let highYield = 0.5;   // 50%
  const tolerance = 0.0001;
  const maxIterations = 100;
  
  for (let i = 0; i < maxIterations; i++) {
    const midYield = (lowYield + highYield) / 2;
    const monthlyYield = midYield / 12;
    
    // Calculate present value with current yield guess
    let pvPayments = 0;
    if (monthlyYield > 0) {
      pvPayments = monthlyPayment * ((1 - Math.pow(1 + monthlyYield, -remainingTermMonths)) / monthlyYield);
    } else {
      pvPayments = monthlyPayment * remainingTermMonths;
    }
    
    const pvBalloon = (balloonPayment || 0) > 0 ? (balloonPayment || 0) / Math.pow(1 + monthlyYield, remainingTermMonths) : 0;
    const totalPV = pvPayments + pvBalloon;
    
    if (Math.abs(totalPV - askingPrice) < tolerance) {
      return `${(midYield * 100).toFixed(2)}%`;
    }
    
    if (totalPV > askingPrice) {
      lowYield = midYield;
    } else {
      highYield = midYield;
    }
    
    if (Math.abs(highYield - lowYield) < tolerance) {
      break;
    }
  }
  
  const finalYield = ((lowYield + highYield) / 2) * 100;
  return `${finalYield.toFixed(2)}%`;
};

export const transformInvestmentWithYield = (investment: any) => {
  // Extract remaining term in months
  let remainingTermMonths = 0;
  if (investment.term_remaining) {
    const monthsMatch = investment.term_remaining.match(/(\d+)\s*months?/i);
    if (monthsMatch) {
      remainingTermMonths = parseInt(monthsMatch[1]);
    }
  }

  const calculatedYield = calculateYield(
    investment.asking_price, 
    investment.monthly_payment,
    remainingTermMonths,
    investment.balloon_payment_amount
  );
  
  return {
    ...investment,
    investor_yield: calculatedYield || investment.investor_yield || ''
  };
};
